module.exports = __webpack_public_path__ + "img/right-arrow.b72f8fe0.png";